var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByXirify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 22,
    viewBox: "0 0 42 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33683",
    "data-name": "Group 33683",
    transform: "translate(-909 -302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33674",
    "data-name": "Group 33674",
    transform: "translate(250 -85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33673",
    "data-name": "Group 33673",
    transform: "translate(-15210 -4352)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887",
    "data-name": "Ellipse 2887",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(15889 4739)",
    fill: "#7e1677"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2072",
    "data-name": "Group 2072",
    transform: "translate(15529.095 4508.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(364.5 234.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    transform: "translate(5.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M411.9,246a1.5,1.5,0,0,1-1.107.484,1.471,1.471,0,0,1-1.074-.45l-4.631-4.617a1.538,1.538,0,0,1-.45-1.089,1.48,1.48,0,0,1,.45-1.074l4.617-4.53a1.519,1.519,0,1,1,2.134,2.163l-2.461,2.078a1.83,1.83,0,0,0-.006,2.791l2.476,2.109A1.536,1.536,0,0,1,411.9,246Z",
    transform: "translate(-404.636 -234.285)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    transform: "translate(0 4.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M364.844,277.181,366.7,275.6a1.372,1.372,0,0,0,0-2.093l-1.845-1.558a1.14,1.14,0,0,1,1.6-1.622l3.463,3.4a1.11,1.11,0,0,1,.338.806,1.154,1.154,0,0,1-.338.817l-3.474,3.463a1.1,1.1,0,0,1-.806.338,1.124,1.124,0,0,1-.831-.363A1.152,1.152,0,0,1,364.844,277.181Z",
    transform: "translate(-364.5 -269.995)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M401.7,332.807a.915.915,0,1,1-.915-.915A.915.915,0,0,1,401.7,332.807Z",
    transform: "translate(-395.343 -319.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M425.512,332.807a.915.915,0,1,1-.915-.915A.915.915,0,0,1,425.512,332.807Z",
    transform: "translate(-416.1 -319.388)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "By",
    transform: "translate(909 318)",
    fill: "#5e5353",
    fontSize: 13,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "By")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByXirify);
export default __webpack_public_path__ + "static/media/ByXirify.54d28665f333a869a7fe7d562ec83c4a.svg";
export { ForwardRef as ReactComponent };